<template>
    <b-container fluid class="p-0">
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">{{ tituloPagina }}</span>
                    <btn-voltar />
                </h6>
            </template>
            <b-tabs v-model="abaAtiva" card>
                <b-tab>
                    <template #title>
                        <font-awesome-icon icon="pencil" class="mr-1 text-info" />
                        Dados iniciais
                    </template>
                    <aba-editar-dados-programacao v-if="showForm && abaAtiva === 0" @atualizarProgramacao="atualizarProgramacao"
                        :prog="prog" />
                </b-tab>
                <b-tab v-if="isEdit" lazy>
                    <template #title>
                        <font-awesome-icon icon="address-card" class="mr-1 text-success" />
                        Atrações Artísticas
                    </template>
                    <aba-editar-atracoes-artisticas :prog="prog"/>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script lang="ts">
import AbaEditarDadosProgramacao from '@/components/licitacoes/programacao-evento/editar-programacao/AbaEditarDadosProgramacao.vue'
import AbaEditarAtracoesArtisticas from '@/components/licitacoes/programacao-evento/editar-programacao/AbaEditarAtracoesArtisticas.vue'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import programacaoService from '@/services/eventos/programacaoService'
import { store } from "@/store"
import { Programacao } from '@/types/eventos/programacao/programacao'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'EditarProgramacao',
    components: {
        AbaEditarDadosProgramacao, AbaEditarAtracoesArtisticas, BtnVoltar
    },
    props: {
        idProgramacao: {
            type: String,
            default: ''
        }
    },
})

@Component
export default class EditarProgramacao extends mixins(UtilsTS, CompProps) {
    prog: Programacao = new Programacao()
    isEdit = false
    abaAtiva = 0 // qual aba está ativa no momento
    showForm = false

    get tituloPagina(): string {
        return `${this.isEdit ? 'Editar' : 'Criar'} Programação`
    }

    get mostrarBtnSave(): boolean {
        return this.abaAtiva === 0
    }

    async mounted(): Promise<void> {
        try {
            store.blockScreen = true
            if (this.idProgramacao.length > 0) {
                this.isEdit = true
                this.prog = await programacaoService.buscarProgramacao(this.idProgramacao)
                this.prog.tratarDadosDaAPI()
            }
        }
        catch (e: unknown) {
            console.error('Erro ao abrir a edição de programação', e)
        } finally {
            this.showForm = true
            store.blockScreen = false
        }
    }

    /**
     * Vamos tentar centralizar aqui as mudanças em flags de controle e no objeto principal 'contrato'
     * @param co nova instância de contrato, recém recebida da API
     */
    async atualizarProgramacao(pg?: Programacao): Promise<void> {
        store.blockScreen = true
        try {
            if (!pg) pg = await programacaoService.buscarProgramacao(this.idProgramacao ?? this.prog.IdProgramacao)
            this.prog = Object.assign(new Programacao(), pg)
            if (pg.IdProgramacao > 0) this.isEdit = true
        } finally {
            store.blockScreen = false
        }
    }
}
</script>

<style></style>